import makeStyles from '@mui/styles/makeStyles';
import BasicButton from '../Buttons/BasicButton';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        boxSizing: 'border-box',
        borderTop: '2px solid transparent',
    },
    borderBottom: {
        borderTopColor: '#fff',
    },
    sortButton: {
        flexGrow: 1,
        padding: theme.spacing(2),
        color: theme.palette.secondary.light,
        '&:hover': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main
        },
        '& svg path': {
            fill: "currentColor"
        },
    },
    sortButtonOpen: {
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            color: theme.palette.secondary.contrastText,
        },
    },
}));
export default function EntryListMenuButton({ children, anchorRef, open, onClick = ()=>{}, icon, label, }) {
    const classes = useStyles();

    return (
        <div className={`${classes.root} ${open?classes.borderBottom:''}`} >
            <BasicButton 
                className={`${classes.sortButton} ${open?classes.sortButtonOpen:''}`}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={onClick}
                startIcon={icon}
            >
                {label ?? children}
            </BasicButton>
        </div>
    );
}